import { cmsDefaults } from './cms-default-data'
/**
 * Note: Any new CMS keys should be added to this array
 * before they are used in the application.
 *
 * Note: Any new keys should be added in alphabetical order.
 */
export const defaultCmsContent = cmsDefaults.reduce(
  (acc, { key, value }) => {
    acc[key] = value
    return acc
  },
  {} as Record<(typeof cmsDefaults)[number]['key'], string>,
)
